const GLOBAL_MEDIA_CONTENT_MODEL_ID = 'cdxGlobalMedia';
export { GLOBAL_MEDIA_CONTENT_MODEL_ID };
//# sourceMappingURL=media.js.map
